<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Languages</h1>
  <div class="d-flex gap-2">
    <button *isGranted="['ROLE_API_LANGUAGE_WRITE']" class="btn btn-primary fw-bold" (click)="create()"><i
    class="bi bi-plus-lg me-2"></i>Add Language
  </button>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Flag</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (language of languages; track language) {
            <tr>
              <td>{{ language.isoCode }}</td>
              <td>{{ language.name }}</td>
              <td><img [ngSrc]="langService.getLanguageFlag(language)" [alt]="language.name" class="country-flag"
              width="24" height="24"></td>
              <td class="text-center">
                <button *isGranted="['ROLE_API_LANGUAGE_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm
                  (click)="delete(language)"><i class="bi bi-trash"></i></button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
